// Prevent right-click context menu on images
exports.onClientEntry = () => {
  document.addEventListener("contextmenu", (e) => {
    if (e.target.tagName === "IMG" || e.target.closest("picture")) {
      e.preventDefault()
    }
  })
}
